import React, { Component } from "react";
import { Chart } from "react-google-charts";
export default class LineGraph extends Component {
  render() {
    const { sensor, kleur } = this.props;
    function grdata(data) {
      const columns = [
        { type: "datetime", label: "datum" },
        { type: "number", label: "temp." },
      ];
      const rows = [];
       data.map(function (a, key) {
         if (a.datum && a.value ) {
        rows.push([new Date(a.datum), a.value]);
         } else {
          return
         }
      });
      return [columns, ...rows];
    }
    return (
      <Chart
        width={"100%"}
        height={"300px"}
        chartType="LineChart"
        loader={<div>Loading Chart</div>}
        data={grdata(sensor.data)}
        options={{
          hAxis: {
            title: "Datum",
            format: 'd MMM HH:mm',
          },
          vAxis: {
            title: "Temp.",
          },
          colors: [kleur],
          series: {
            1: { curveType: "function" },
          },
          explorer: {
            axis: "horizontal",
            actions: ["dragToZoom", "rightClickToReset"],
          },
        }}
        rootProps={{ "data-testid": "2" }}
      />
    );
  }
}
